import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import { toast } from 'react-toastify';
import RemarkOptionList from '../../../components/MasterData/RemarkOption/list';
import constant from '../../../constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_remark_option_visibility, v3_remark_options } from '../../../actions/v3/masterData';
import { replacePageState } from '../../../utils';

const ListRemarkOptions = (props) => {
    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit] = useState(10);

    useEffect(() => {
        v3_remark_options(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.listRemarkOptionMasterData.url, {
                    page: currentPage,
                });
            } else {
                toast.error(res.error?.message || res.error);
            }
        });
    }, [currentPage, limit, props.history]);

    const onChangeVisibility = (record) => {
        const newStatus = !record.IS_ACTIVE;

        v3_remark_option_visibility(record.ID, newStatus)
            .then((res) => {
                if (res.status) {
                    setData((prevState) => ({
                        ...prevState,
                        remarkOptions: prevState.remarkOptions.map((item) => (
                            item.ID === record.ID
                                ? { ...item, IS_ACTIVE: newStatus }
                                : item
                        )),
                    }));

                    toast.success(res.result.message);
                } else {
                    toast.error(res.error?.message || 'Failed to update remark option visibility');
                }
            })
            .catch((err) => {
                console.error(err);
                toast.error('An error occurred while updating remark option visibility');
            });
    };

    return (
        <Layout title="Remark Options">
            {data && (
                <RemarkOptionList
                    onChangeVisibility={onChangeVisibility}
                    limit={limit}
                    data={data}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </Layout>
    );
};

export default ListRemarkOptions;
